import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AppShell } from "@/components/layout/AppShell";
import { CookieConsent, BackToTop } from "@/components/SiteWidgets";

import Landing from "@/pages/Landing";
import Login, { Signup } from "@/pages/Login";
import AcceptInvite from "@/pages/AcceptInvite";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Contacts from "@/pages/Contacts";
import Contact360 from "@/pages/Contact360";
import Companies from "@/pages/Companies";
import CompanyDetail from "@/pages/CompanyDetail";
import Leads from "@/pages/Leads";
import Pipeline from "@/pages/Pipeline";
import Deals from "@/pages/Deals";
import DealWorkspace from "@/pages/DealWorkspace";
import Tasks from "@/pages/Tasks";
import Sequences from "@/pages/Sequences";
import Campaigns from "@/pages/Campaigns";
import Products from "@/pages/Products";
import Copilot from "@/pages/Copilot";
import GrowthEngine from "@/pages/GrowthEngine";
import Insights from "@/pages/Insights";
import Agents from "@/pages/Agents";
import AgentDetail from "@/pages/AgentDetail";
import Workflows from "@/pages/Workflows";
import Analytics from "@/pages/Analytics";
import Integrations from "@/pages/Integrations";
import Settings from "@/pages/Settings";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import PlatformAdmin from "@/pages/PlatformAdmin";
import Legal from "@/pages/Legal";
import AuthCallback from "@/pages/AuthCallback";
import SelectPlan from "@/pages/SelectPlan";
import { Customers, Renewals, Forecast, Revenue, Inbox, Audiences, Forms, Knowledge, AutomationLogs } from "@/pages/modules";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/accept-invite" element={<AcceptInvite />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/select-plan" element={<SelectPlan />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/legal/:doc" element={<Legal />} />
          <Route path="/app" element={<AppShell />}>
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<Leads />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="contacts/:id" element={<Contact360 />} />
            <Route path="companies" element={<Companies />} />
            <Route path="companies/:id" element={<CompanyDetail />} />
            <Route path="deals" element={<Deals />} />
            <Route path="deals/:id" element={<DealWorkspace />} />
            <Route path="products" element={<Products />} />
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="sequences" element={<Sequences />} />
            <Route path="forecast" element={<Forecast />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="audiences" element={<Audiences />} />
            <Route path="forms" element={<Forms />} />
            <Route path="inbox" element={<Inbox />} />
            <Route path="copilot" element={<Copilot />} />
            <Route path="growth" element={<GrowthEngine />} />
            <Route path="agents" element={<Agents />} />
            <Route path="agents/:id" element={<AgentDetail />} />
            <Route path="insights" element={<Insights />} />
            <Route path="knowledge" element={<Knowledge />} />
            <Route path="workflows" element={<Workflows />} />
            <Route path="automation-logs" element={<AutomationLogs />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="revenue" element={<Revenue />} />
            <Route path="customers" element={<Customers />} />
            <Route path="renewals" element={<Renewals />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="admin" element={<Admin />} />
            <Route path="platform-admin" element={<PlatformAdmin />} />
            <Route path="account" element={<Account />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <BackToTop />
        <CookieConsent />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
